import React from "react";


const VisionMissionPage = () => {
  return (
    <div style={{ backgroundColor: "var(--white-cream)" }}>

      {/* HERO */}
      <section
        className="text-center py-5"
        style={{
          background: "linear-gradient(135deg, var(--saffron-deep), var(--white-pure))",
           padding: '60px 0 40px',
        marginTop: '75px',
        }}
      >
        <h1 className="fw-bold" style={{ color: "var(--saffron-dark)" }}>
          पंडित धीरेंद्र कुमार शर्मा
        </h1>
        <p className="text-muted">144 मोहम्मदी विधानसभा प्रत्याशी</p>
        <h5 style={{ color: "var(--saffron-deep)" }}>
          जनता की सेवा, हमारा संकल्प
        </h5>
      </section>

      <div className="container my-5">

        {/* VISION */}
        <section className="mb-5">
          <h2 style={{ color: "var(--saffron-dark)" }}>हमारी दृष्टि</h2>
          <div className="p-4 shadow rounded" style={{ backgroundColor: "var(--saffron-soft)" }}>
            मोहम्मदी विधानसभा को एक सुरक्षित, विकसित और आत्मनिर्भर क्षेत्र बनाना –
            जहाँ हर परिवार को मूलभूत सुविधाएँ मिलें, युवाओं को रोजगार के अवसर हों,
            और किसानों को उनकी मेहनत का सम्मानजनक मूल्य मिले।
          </div>
        </section>

        {/* GOALS */}
        <section className="mb-5">
          <h2 style={{ color: "var(--saffron-dark)" }}>हमारा लक्ष्य</h2>
          <div className="row">
            {[
              "हर गाँव तक साफ पानी और बेहतर सड़क",
              "हर युवा को रोजगार और कौशल विकास",
              "हर किसान को उचित मूल्य और संसाधन",
              "हर परिवार को सुरक्षा और सम्मान"
            ].map((item, i) => (
              <div className="col-md-6 mb-3" key={i}>
                <div
                  className="p-3 rounded shadow-sm"
                  style={{
                    backgroundColor: "var(--white-pure)",
                    borderLeft: "5px solid var(--saffron-deep)"
                  }}
                >
                  {item}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* MISSION */}
        <section className="mb-5">
          <h2 style={{ color: "var(--saffron-dark)" }}>हमारा मिशन</h2>
          <div className="p-4 shadow rounded" style={{ backgroundColor: "var(--white-off)" }}>
            <p>
              जनता के साथ मिलकर पारदर्शी और जवाबदेह शासन के माध्यम से समस्याओं का समाधान करना।
            </p>
            <ul>
              <li>शिकायतों का त्वरित समाधान</li>
              <li>योजनाओं की पारदर्शी मॉनिटरिंग</li>
              <li>जनता के साथ नियमित संवाद</li>
            </ul>
          </div>
        </section>

        {/* PRIORITIES */}
        <section className="mb-5">
          <h2 style={{ color: "var(--saffron-dark)" }}>मिशन प्राथमिकताएँ</h2>

          <div className="row">
            {[
              "स्वच्छ पेयजल",
              "पक्की सड़कें",
              "पाइपलाइन परियोजनाएँ",
              "सड़क मरम्मत",
              "किसान विकास",
              "रोजगार अवसर",
              "कृषि संसाधन",
              "युवा सशक्तिकरण",
              "स्वास्थ्य सेवाएँ",
              "महिला सुरक्षा",
              "शिक्षा सुधार",
              "आर्थिक सशक्तिकरण"
            ].map((item, i) => (
              <div className="col-md-4 mb-3" key={i}>
                <div
                  className="p-3 rounded shadow-sm text-center h-100"
                  style={{
                    backgroundColor: "var(--white-pure)",
                    border: "1px solid var(--saffron-light)"
                  }}
                >
                  <strong style={{ color: "var(--saffron-deep)" }}>
                    {item}
                  </strong>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* SPECIAL COMMITMENTS */}
        <section className="mb-5">
          <h2 style={{ color: "var(--saffron-dark)" }}>विशेष संकल्प</h2>

          <div className="row">

            {/* HEALTH */}
            <div className="col-md-4 mb-3">
              <div className="p-4 rounded shadow-sm h-100" style={{
                backgroundColor: "var(--white-pure)",
                borderTop: "4px solid var(--saffron-deep)"
              }}>
                <h5 style={{ color: "var(--saffron-deep)" }}>
                  बेहतर स्वास्थ्य, सुलभ चिकित्सा
                </h5>
                <p>
                  मोहम्मदी के हर गाँव तक प्राथमिक चिकित्सा केंद्रों का जाल बिछाना और
                  सरकारी अस्पतालों में आधुनिक मशीनों व विशेषज्ञों की उपलब्धता सुनिश्चित करना।
                </p>
              </div>
            </div>

            {/* WOMEN */}
            <div className="col-md-4 mb-3">
              <div className="p-4 rounded shadow-sm h-100" style={{
                backgroundColor: "var(--white-pure)",
                borderTop: "4px solid var(--saffron-deep)"
              }}>
                <h5 style={{ color: "var(--saffron-deep)" }}>
                  नारी शक्ति का सम्मान और सुरक्षा
                </h5>
                <p>
                  सुरक्षित सार्वजनिक स्थान, पिंक बूथ और 'शक्ति सहायता केंद्र' के माध्यम से
                  महिलाओं को आत्मनिर्भर बनाना।
                </p>
              </div>
            </div>

            {/* LAW */}
            <div className="col-md-4 mb-3">
              <div className="p-4 rounded shadow-sm h-100" style={{
                backgroundColor: "var(--white-pure)",
                borderTop: "4px solid var(--saffron-deep)"
              }}>
                <h5 style={{ color: "var(--saffron-deep)" }}>
                  भू-माफिया मुक्त मोहम्मदी
                </h5>
                <p>
                  अवैध कब्जों के खिलाफ जीरो टॉलरेंस नीति और त्वरित कार्रवाई।
                </p>

                <div className="mt-3 p-2 text-center rounded"
                  style={{
                    backgroundColor: "var(--saffron-light)",
                    fontWeight: "bold",
                    color: "var(--saffron-dark)"
                  }}>
                  दबंगों का खौफ खत्म होगा, कानून का राज चलेगा
                </div>
              </div>
            </div>

          </div>
        </section>

        {/* COMMITMENT */}
        <section className="mb-5">
          <h2 style={{ color: "var(--saffron-dark)" }}>हमारे मुख्य संकल्प</h2>
          <div className="p-4 rounded shadow" style={{ backgroundColor: "var(--saffron-soft)" }}>
            <ul>
              <li>वाद नहीं, काम दिखेगा</li>
              <li>हर गाँव, हर घर – विकास का अधिकार</li>
              <li>जनता की समस्या, हमारी प्राथमिकता</li>
            </ul>
          </div>
        </section>

        {/* CLOSING */}
        <section className="text-center">
          <blockquote className="p-4 shadow rounded"
            style={{
              backgroundColor: "var(--white-pure)",
              borderLeft: "5px solid var(--saffron-deep)"
            }}>
            <p>
              "मैं सिर्फ चुनाव नहीं लड़ रहा, मैं मोहम्मदी के भविष्य को बेहतर बनाने का संकल्प लेकर आया हूँ।
              आपका विश्वास ही मेरी सबसे बड़ी ताकत है।"
            </p>
            <footer style={{ color: "var(--saffron-dark)" }}>
              – पंडित धीरेंद्र कुमार शर्मा
            </footer>
          </blockquote>
        </section>

      </div>
    </div>
  );
};

export default VisionMissionPage;